module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_07.29cde92b.svg";